module.exports = __webpack_public_path__ + "img/PHOTO1.f2673a2c.png";